var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{ref:_vm.ref,scopedSlots:_vm._u([{key:"default",fn:function({ validate, pristine, reset }){return [_vm._t("default",null,{"handleSubmit":_vm.handleSubmit,"reset":reset,"validate":validate,"pristine":pristine})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }